import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Bell } from 'lucide-react';
import { useUnreadCount } from '@/hooks/useNotifications';
import { NotificationList } from './NotificationList';

interface NotificationBellProps {
  iconClassName?: string;
  variant?: 'light' | 'dark';
}

export function NotificationBell({ iconClassName = 'h-5 w-5', variant = 'dark' }: NotificationBellProps) {
  const { data: unreadCount } = useUnreadCount();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className={`relative p-2 rounded-lg transition-colors ${
          variant === 'light'
            ? 'text-white/80 hover:text-white hover:bg-white/10'
            : 'text-foreground/80 hover:text-foreground hover:bg-muted'
        }`}>
          <Bell className={iconClassName} />
          {(unreadCount ?? 0) > 0 && (
            <span className="absolute top-1 right-1 flex items-center justify-center min-w-[16px] h-4 px-1 text-[10px] font-bold text-white bg-primary rounded-full">
              {unreadCount! > 99 ? '99+' : unreadCount}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-auto" align="end" sideOffset={8}>
        <NotificationList />
      </PopoverContent>
    </Popover>
  );
}
